function debounce<T extends (...args: any[]) => void>(fn: T, ms: number): T {
    let timer: ReturnType<typeof setTimeout>;
    return ((...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    }) as unknown as T;
}

export function maskEmail(email: string): string {
    const [localPart, domainPart] = email.split('@');
    if (!localPart || !domainPart) {
        throw new Error('Некорректный имейл');
    }

    // const maskedLocalPart = localPart.charAt(0) + '*'.repeat(localPart.length - 1);
    const maskedLocalPart = localPart.charAt(0) + '*'.repeat(3);
    return `${maskedLocalPart}@${domainPart}`;
}

export const shortenText = (text: string, max: number = 64) => {
    // Если больше, то сокращается
    if (text.length <= max) {
        return text
    }
    const useful_text_length = max - 3;
    const useful_text = text.slice(0, useful_text_length)
    return `${useful_text}...`
}


export const debouncedSearch = debounce((searchTerm: string, callback: (term: string) => void) => {
    callback(searchTerm);
}, 500);


export const aggregateUniqueStrings = (items: string[]): string[] => {
    const uniqueUuids = new Set<string>();

    items.forEach(item => {
        uniqueUuids.add(item);
    });

    return Array.from(uniqueUuids);
};

export default function morph(int: number, array: Array<any>) {
    return (array = array || ['товар', 'товара', 'товаров']) && array[(int % 100 > 4 && int % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(int % 10 < 5) ? int % 10 : 5]];
}


export const nounDeclension = (basicForm: string, count: number) => {
    // Изменение окончания существительных, пока м.р. ед.ч. - для слова участник
    const preCount = count % 100;
    if (4 < preCount && preCount < 21) {
        return basicForm + 'ов';
    }
    const remainder = preCount % 10;
    switch (remainder) {
        case 1:
            return basicForm + '';
        case 2:
        case 3:
        case 4:
            return basicForm + 'а';
        default:
            return basicForm + 'ов';
    }
};

export const addUniqueToArray = <T>(arr: T[], str: T): T[] => {
    return arr.includes(str) ? arr : [...arr, str];
};